(() => {
  if (customElements.get('featured-product-price')) return;

  class FeaturedProductPrice extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
    }

    disconnectedCallback() {
      this.variantChangeUnsubscriber?.();
    }

    onVariantChange(event) {
      if (event.data.sectionId !== this.dataset.sectionId) return;
      const variant = event.data.variant;
      if (!variant) return;

      const subscriptionV2El = document.querySelector(
        `subscription-form-v2[data-section-id="${this.dataset.sectionId}"]`
      );
      if (subscriptionV2El) return;

      const subscriptionEl = document.querySelector(
        `subscription-option[data-section-id="${this.dataset.sectionId}"]`
      );
      const isSubscribe =
        subscriptionEl?.querySelector('.js-subscription-option-purchase-type:checked')?.value === 'subscribe';

      if (isSubscribe) return;

      this.updatePriceBlock(variant);
    }

    updatePriceBlock(variant) {
      const priceBlock = document.getElementById(`price-${this.dataset.sectionId}`);
      if (!priceBlock) return;
      const priceEl = priceBlock.querySelector('.price');
      if (!priceEl) return;

      const price = variant.price;
      const compareAtPrice = variant.compare_at_price;
      const isOnSale = compareAtPrice && compareAtPrice > price;
      const available = variant.available;

      const saleEl = priceEl.querySelector('.price__sale');
      const saleItem = saleEl?.querySelector('.price-item--sale');
      const regularItem = priceEl.querySelector('.price__regular .price-item--regular');

      if (saleItem) saleItem.textContent = this.formatMoney(price);
      if (regularItem) regularItem.textContent = this.formatMoney(price);

      let compareItem = saleEl?.querySelector('s.price-item--regular');

      if (isOnSale) {
        if (!compareItem && saleEl && saleItem) {
          const compareWrapper = document.createElement('span');
          compareItem = document.createElement('s');
          compareItem.className = 'price-item price-item--regular';
          compareWrapper.appendChild(compareItem);
          saleEl.insertBefore(compareWrapper, saleItem);
        }
        if (compareItem) {
          compareItem.textContent = this.formatMoney(compareAtPrice);
          const compareWrapper = compareItem.closest('span');
          if (compareWrapper) compareWrapper.style.display = '';
        }
      } else if (compareItem) {
        const compareWrapper = compareItem.closest('span');
        if (compareWrapper) compareWrapper.style.display = 'none';
      }

      priceEl.classList.toggle('price--on-sale', !!isOnSale);
      priceEl.classList.toggle('price--sold-out', !available);

      this.updatePerNightBadge(priceEl, variant, price);
      this.updatePriceDiffBadge(priceEl, price, compareAtPrice || price);
    }

    updatePerNightBadge(priceEl, variant, price) {
      const badge = priceEl.querySelector('.pernight-bedge:not(.price-diff-badge)');
      if (!badge) return;

      const days = this.resolveNightsPerUnit(priceEl, variant);
      const perNight = Math.round(price / days);
      const currentText = badge.textContent.trim();
      const suffix = currentText.replace(/[^a-zA-Z\s\/]/g, '').trim();
      badge.textContent = `${this.formatMoney(perNight)} ${suffix}`.trim();
    }

    resolveNightsPerUnit(priceEl, variant) {
      const raw = priceEl?.dataset?.variantNights;
      if (raw && variant?.id) {
        try {
          const nightsMap = JSON.parse(raw);
          const nights = nightsMap[String(variant.id)];
          if (nights != null && Number(nights) > 0) return Number(nights);
        } catch (e) {}
      }

      let days = 30;
      if (Array.isArray(variant?.options)) {
        variant.options.forEach((opt) => {
          const val = String(opt).toLowerCase();
          if (val.includes('2-pack')) days = 60;
          else if (val.includes('3-pack')) days = 90;
          else if (val.includes('4-pack')) days = 120;
        });
      }
      return days;
    }

    updatePriceDiffBadge(priceEl, price, compareAtPrice) {
      const badge = priceEl.querySelector('.price-diff-badge');
      if (!badge) return;

      const diff = compareAtPrice - price;
      const diffRounded = Math.round(diff / 100) * 100;
      if (diffRounded > 0) {
        const formatted = this.formatMoney(diffRounded).replace(/[.,]00(?=[^0-9]|$)/, '');
        badge.textContent = `${formatted} OFF`;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, window.Shopify.moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }
  }

  customElements.define('featured-product-price', FeaturedProductPrice);
})();
